@if (isProductionWorkspace) {
  <button
    mat-flat-button
    color="primary"
    (click)="submitOrConfirm()"
    [disabled]="submitDisabled$ | async"
  >
    SUBMIT
  </button>
}
